import { mp3Importer } from "@/modules/moduleImporter";
import { getBasePcode } from "@/modules/gamePcode";

/**
 * Text-to-Speech Class
 */
export default class TTS {
	//Note: always add new game into excluded pcodes here
	private readonly exclusion = [
		"m21", "m22", "m23", "m24",
		"m25", "m26", "m27", "m28",
		"m29", "m30", "m31", "m32", "m33", "m38"
	];

	private readonly numbersOnly = ["p6", "p7", "p9", "p12", "m6", "m8"];
	
	pcode: string;
	basePcode: string;
	soundFiles: HTMLAudioElement[];

	constructor(pcode: string) {
		// console.log("importing sound files for " + pcode);
		
		this.pcode = pcode;
		this.basePcode = getBasePcode(pcode);
		
		// console.log("Loading TTS for ", pcode);
		
		if (this.exclusion.includes(this.basePcode)) {
			// console.log("excluded pcode: ", pcode);
			return;
		}
		
		let skip = false;
		
		this.exclusion.some(item => {
			skip = this.basePcode.includes(item);
			return skip;
		});
		
		if (skip)
			return;
		
		this.soundFiles = (this.numbersOnly.includes(this.basePcode)) ?
			mp3Importer("result_numbers") :
			mp3Importer("result_" + this.basePcode);
	}
}